import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class HospitalService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getHospitalList(pageno,limit,qstring)
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-hospital-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addHospital(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-hospital',formData,{headers:webheader})
  }

  getHospitalData(data){
    let hospital_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-hospital-data/'+ hospital_id, {headers:webheader})
  }

  updateHospital(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-hospital-data',formData,{headers:webheader})
  }

  uploadHospitalFile(data,formData)
  {
        let hospital_id = data;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-hospital-docs/'+hospital_id,formData,{headers:webheader})
  }

  addTreatmentCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-hospital-TreatmentCost',data,{headers:webheader})
  }

  updateTreatmentCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-hospital-TreatmentCost',data,{headers:webheader})
  }

  getTreatmentcostList(data){
      let hospital_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-hospital-treatment-cost-list/'+ hospital_id,{headers:webheader})
  }

  updateHospitalStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-hospital-status',data,{headers:webheader})
  }

  getTreatCostData(data){
    let record_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-hospital-treatCost-data/'+ record_id, {headers:webheader})
  }

  showingOnLP(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'display-hospital-lp',data,{headers:webheader})
  }


  addTpaCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-hospital-TpaCost',data,{headers:webheader})
  }

  updateTpaCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-hospital-TpaCost',data,{headers:webheader})
  }

  getTpaCostList(data){
      let hospital_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-hospital-tpa-cost-list/'+ hospital_id,{headers:webheader})
  }

  getTpaCostData(data){
    let record_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-hospital-tpaCost-data/'+ record_id, {headers:webheader})
  }

//----------------------Localities-------------------------------//
getLocalities()
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-localities',{headers:webheader})
}
//----------------------Amenities-------------------------------//
getAmenities()
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-amenities',{headers:webheader})
}


//--------------------Delete Hospital Document----------------//
deleteDocuments(data)
{
  let document_id = data.id;
  let webheader = this.sharedapi.getHeaders();
  return this.http.delete(apiUrl+'delete-hospital-document/'+document_id,{headers:webheader})
}

uploadcsvHospitalRankingUpdate(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'import-hospital-ranking-update-csv',data,{headers:webheader})
}

//--------------------Update Hospital Data From Csv(Import)----------------//
updateHospitalDataFromCsv(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-hospital-data-from-csv',data,{headers:webheader})
}

}
